import React, { createContext, useContext, useState, useMemo } from "react";

const LeadOptimisticStateContext = createContext();

export const LeadOptimisticStateProvider = ({ children }) => {
  const [leadData, setLeadData] = useState(null);

  const [localStage, setLocalStage] = useState(null);
  const [localSubStage, setLocalSubStage] = useState(null);
  const [localPriority, setLocalPriority] = useState(null);
  const [localInteractionLevel, setLocalInteractionLevel] = useState(null);

  const value = useMemo(() => ({
    leadData,
    setLeadData,

    localStage,
    setLocalStage,

    localSubStage,
    setLocalSubStage,

    localPriority,
    setLocalPriority,

    localInteractionLevel,
    setLocalInteractionLevel
  }), [
    leadData,
    localStage,
    localSubStage,
    localPriority,
    localInteractionLevel
  ]);

  return (
    <LeadOptimisticStateContext.Provider value={value}>
      {children}
    </LeadOptimisticStateContext.Provider>
  );
};

export const useLeadOptimisticState = () => {
  return useContext(LeadOptimisticStateContext);
};
